export default function trim(label) {
  return label.replace(/n\d* /g, '');
}
